'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var url = require('url');
var _ = require('lodash');
var qs = require('pn-qs');

var Converter = function () {
  function Converter(destType, configList) {
    _classCallCheck(this, Converter);

    this.destType = destType;
    this.configList = configList;
  }

  _createClass(Converter, [{
    key: 'convert',
    value: function convert(link) {
      link = link.replace(/^piaoniu:\/\//, '');
      var matchResult = this.matchConfigFromLink(link);
      if (!matchResult) {
        return link;
      }
      var type = matchResult.type,
          config = matchResult.config;

      var matchedPattern = config[type];
      var destPattern = config[this.destType];

      var params = this.paramsFromLinkAndMatchedPattern(link, matchedPattern);
      var destLink = this.fillParamsToDestPattern(params, destPattern);
      return destLink;
    }
  }, {
    key: 'paramsFromLinkAndPath',
    value: function paramsFromLinkAndPath(link, pattern, path) {
      var _this = this;

      var parsedLink = url.parse(link);
      var result = {};
      var linkSegs = parsedLink.pathname.split('/');
      var patternSegs = path.split('/');

      linkSegs.forEach(function (seg, i) {
        var pattern = patternSegs[i];
        if (pattern.match(/^{[^}]+}$/)) {
          var name = _this.dropBrace(pattern);
          if (name && seg) {
            result[name] = seg;
          }
        }
      });

      return result;
    }
  }, {
    key: 'paramsFromLinkAndQuery',
    value: function paramsFromLinkAndQuery(link, pattern, query) {
      var linkQuery = url.parse(link, true).query;
      var patternPathParams = this.patternPathParams(pattern);
      var patternParams = _.merge({}, patternPathParams, query);

      var result = {};
      for (var key in linkQuery) {
        var value = linkQuery[key];
        var patternKey = null;
        if (patternParams[key]) {
          patternKey = this.dropBrace(patternParams[key]);
        }
        key = patternKey || key;
        result[key] = value;
      }
      return result;
    }
  }, {
    key: 'paramsFromLinkAndMatchedPattern',
    value: function paramsFromLinkAndMatchedPattern(link, pattern) {
      var parsed = url.parse(pattern, true);
      var queryParams = this.paramsFromLinkAndQuery(link, pattern, parsed.query);
      var pathParams = this.paramsFromLinkAndPath(link, pattern, parsed.path);

      return _.merge({}, pathParams, queryParams);
    }
  }, {
    key: 'dropBrace',
    value: function dropBrace(str) {
      return str.replace(/[\{\}]/g, '');
    }
  }, {
    key: 'patternPathParams',
    value: function patternPathParams(pattern) {
      var _this2 = this;

      var segments = pattern.split('/');
      var params = {};
      segments.forEach(function (seg) {
        var match = seg.match(/{[^}]+}/);
        if (match) {
          params[_this2.dropBrace(match[0])] = match[0];
        }
      });
      return params;
    }
  }, {
    key: 'fillParamsToDestPattern',
    value: function fillParamsToDestPattern(params, destPattern) {
      var result = destPattern;
      var restParams = {};
      // abc/{id}?a=1 -> abc/1?a=1
      for (var key in params) {
        var keyPattern = '{' + key + '}';
        if (result.match(keyPattern)) {
          result = result.replace(keyPattern, params[key]);
        } else {
          restParams[key] = params[key];
        }
      }

      var parsed = url.parse(result, true);
      var query = parsed.query;
      for (var _key in restParams) {
        query[_key] = restParams[_key];
      }

      if (Object.keys(query).length) {
        parsed.search = '?' + qs.stringify(query);
      }
      result = url.format(parsed);
      return result;
    }
  }, {
    key: 'matchConfigFromLink',
    value: function matchConfigFromLink(link) {
      for (var i = 1; i < this.configList.length; i++) {
        var config = this.configList[i];
        var type = this.matchedTypeWithConfigAndLink(config, link);
        if (type) {
          return { type: type, config: config };
        }
      }
      return null;
    }
  }, {
    key: 'matchedTypeWithConfigAndLink',
    value: function matchedTypeWithConfigAndLink(config, link) {
      link = link.replace(/^piaoniu:\/\//, '');
      var parsed = url.parse(link);
      for (var type in config) {
        var typeUrl = config[type];
        var pathOfTypeUrl = typeUrl.split('?')[0];
        var regStr = '^' + pathOfTypeUrl.replace(/{[^}]+}/g, '(\\w+)') + '$';
        var reg = new RegExp(regStr);
        var match = parsed.pathname && parsed.pathname.match(reg);
        if (match) {
          return type;
        }
      }
      return false;
    }
  }]);

  return Converter;
}();

module.exports = Converter;


//////////////////
// WEBPACK FOOTER
// ./~/pn-link-coverter/dist/index.js
// module id = 1913
// module chunks = 148